import { render } from "./newsList.vue?vue&type=template&id=43d2c2c2"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/website/newsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43d2c2c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43d2c2c2', __exports__)) {
    console.log('reload')
    api.reload('43d2c2c2', __exports__)
  }
  
  module.hot.accept("./newsList.vue?vue&type=template&id=43d2c2c2", () => {
    console.log('re-render')
    api.rerender('43d2c2c2', render)
  })

}


export default __exports__